module.exports = __webpack_public_path__ + "img/keywords.30987075.svg";